import React, { Component } from "react";
// import classnames from "classnames";
import Alert from "react-s-alert";
import "react-responsive-modal/styles.css";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import moment from "moment";
// import { Modal } from "react-responsive-modal";
import { Modal } from "react-bootstrap";
import { PopupActionButton } from "../../buttonReusableComponent/ButtonReusableComponent";
// import { NewInputText } from "../../inputReusableComponent/InputBoxComponent";
// import InputNumberFunc from "../../../../function/InputNumberFunc";

import {
  Select,
  MenuItem,
  InputLabel,
  TextField,
  FormControl,
} from "@material-ui/core";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  change_table_status_table_management,
  vendor_seated_waittime_request,
} from "../../../../store/actions/dashboardAction/addingAction";
import {
  rsvp_assign_table_event_request,
  fetch_single_event_rsvp_data_information,
} from "../../../../store/actions/RsvpEventDashboard/RsvpEventDashboardAction";
import { sa_vd_reset_diner_request } from "../../../../store/actions/SuperAdminVendorDashboardAction/SuperAdminSeatingAction";
import { vendor_get_available_table_action } from "../../../../store/actions/dashboardAction/addingAction";
import { get_new_subscription_for_vendor } from "../../../../store/actions/authAction";
import isEmpty from "../../../../store/validation/is-Empty";

export class TableNumberAdded extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      enterTableNumber: "",
      alreadyAddedTableNumber: "",
      diner_id: "",
      allAvailableTable: [],
      errors: {},
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.allDataProps) !== nextState.diner_id ||
      !isEmpty(nextProps.wholeDataObj) !== nextState.alreadyAddedTableNumber ||
      !isEmpty(nextProps.getAvailableTableData) !==
        nextState.allAvailableTable ||
      nextProps?.enterTableModal !== nextState.open
    ) {
      // let availableTable =
      //   nextProps.subscription?.casual_dining_status?.seating?.table_management?.table_setup?.table?.filter(
      //     (tableStatus) => tableStatus.status === "AVAILABLE"
      //   );
      return {
        // allAvailableTable: availableTable,
        allAvailableTable: nextProps.getAvailableTableData,
        diner_id: nextProps.allDataProps,
        alreadyAddedTableNumber: nextProps.wholeDataObj?.table_number,
        open: nextProps?.enterTableModal || nextState.open,
      };
    } else {
      return null;
    }
  }

  onOpenModal = (e) => {
    // console.log(this.props);
    let startDate = moment(new Date()).format("YYYY-MM-DD");
    let finalStartDate = startDate + " " + "00:00";
    let endDate = moment(new Date()).format("YYYY-MM-DD");
    let finalendDate = endDate + " " + "23:59";

    if (
      this.props?.subscription?.casual_dining_status?.seating?.table_management
        ?.value ||
      this.props?.subscription?.multi_service_business_status?.seating
        ?.table_management?.value
    ) {
      if (this.props?.setTablePopUp) {
        this.props.setTablePopUp();
      }
      this.setState({ open: true });
      this.props.vendor_get_available_table_action(
        this.props.auth.user.VendorUser._id,
        finalStartDate,
        finalendDate,
        this.props.auth.user.accessToken
      );
    } else {
      this.onSubmitHandler(e);
    }
  };

  onCloseModal = (e) => {
    this.setState({ open: false, enterTableNumber: "" });
    if (this.props?.setTablePopUpClose) {
      this.props.setTablePopUpClose();
    }
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  onChange = (e) => {
    this.setState({
      enterTableNumber: e.target.value,
    });
  };

  onCallBackFunc = (e) => {
    this.onCloseModal();
    this.props.get_new_subscription_for_vendor({
      vendor_id:
        this.props.actionBy === "ADMIN"
          ? this.props.adminSendVendorId
          : this.props.auth.user.VendorUser._id,
    });
    if (this.props.closedMainModal) {
      this.props.closedMainModal();
    }
  };

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/
  onSubmitHandler = (e, type) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.diner_id;
    const vendor_id =
      this.props.actionBy === "ADMIN"
        ? this.props.adminSendVendorId
        : this.props.auth.user.VendorUser._id;
    if (this.props.actionBy === "RsvpTable") {
      const eventId = this.props.eventId._id;
      const formData = {
        vendor_id: vendor_id,
        event_id: this.props.getSingleEventInfo._id,
      };
      const waitTimeData = {
        event_status: "SEATED",
        wait_time: parseInt(0),
        table_number: this.state.enterTableNumber,
      };
      this.props?.displayButton === "directSingle"
        ? this.props.rsvp_assign_table_event_request(
            formData,
            waitTimeData,
            eventId,
            token,
            this.onSuccess,
            () => {},
            type === "skip" ? false : true
          )
        : this.props.rsvp_assign_table_event_request(
            formData,
            waitTimeData,
            eventId,
            token,
            this.onSuccess,
            () => {},
            type === "skip" ? true : false
          );
    } else {
      const formData = {
        table_number:
          this.state.enterTableNumber !== ""
            ? this.state.enterTableNumber
            : this.state.alreadyAddedTableNumber,
        diner_status: "SEATED",
        wait_time: parseInt(0),
        seatedTime: new Date().getTime(),
        vendor: vendor_id,
      };
      if (type !== "skip" && this.state.enterTableNumber !== "") {
        formData.old_table_number = this.state.alreadyAddedTableNumber;
      }
      if (this.props.actionBy === "ADMIN") {
        this.props.sa_vd_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token,
          this.onCallBackFunc
        );
      } else {
        this.props.vendor_seated_waittime_request(
          formData,
          diner_id,
          vendor_id,
          token,
          this.onCallBackFunc
        );
      }
      this.props.change_table_status_table_management(
        this.props.subscription_id,
        this.state.enterTableNumber,
        "OCCUPIED",
        token,
        vendor_id
      );
    }
  };

  onSuccess = (e) => {
    const token = this.props.auth.user.accessToken;
    const formData = {
      vendor_id: this.props.eventId.vendor_id,
      event_id: this.props.eventId._id,
    };
    this.props.fetch_single_event_rsvp_data_information(
      formData,
      token,
      this.onSuccessGet
    );
  };

  onSuccessGet = (e) => {
    console.log("Rsvp");
  };

  onSkipModal = (e) => {
    e.preventDefault();
    this.onSubmitHandler(e, "skip");
  };

  render() {
    const { open, errors, enterTableNumber } = this.state;
    return (
      <>
        {this.props.displayButton === "directSingle" ? (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass={
              this.props.buttonClass ? this.props.buttonClass : "smallsave"
            }
            onClick={this.onSubmitHandler}
            disabled={this.props.disabled}
            buttonImage={this.props.IconButton}
          />
        ) : this.props.displayButton === "mobile" ? (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass={this.props.buttonClass}
            onClick={this.onOpenModal}
            disabled={this.props.disabled}
            buttonImage={this.props.IconButton}
          />
        ) : (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            // buttonClass="yesButton"
            buttonClass={
              this.props.buttonClass ? this.props.buttonClass : "smallsave"
            }
            onClick={this.onOpenModal}
            disabled={this.props.disabled || false}
            buttonImage={this.props.IconButton}
          />
        )}
        {/* <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "small-popup",
            closeButton: "customCloseButton",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        > */}
        <Modal
          show={open}
          onHide={this.onCloseModal}
          centered
          size="md"
          className="tablenumber-enter-pop-up"
        >
          <Modal.Header className="border-0 px-md-4 pb-md-0" closeButton>
            <Modal.Title className="f24-700">Table Number</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-md-4 pt-md-0">
            <div>
              <h4 className="f16-700 mb-3">
                Currently Assigned Table:{" "}
                <span className={`f13-500`}>
                  {this.state.alreadyAddedTableNumber}
                </span>
              </h4>
            </div>
            <div className="enter-table-number">
              <Form noValidate onSubmit={this.onSubmitHandler}>
                {(this.props.subscription?.casual_dining_status?.seating
                  ?.table_management?.value ||
                  this.props.subscription?.multi_service_business_status
                    ?.seating?.table_management?.value) &&
                this.state.allAvailableTable.filter(
                  (data) => data.status === "AVAILABLE"
                ).length > 0 ? (
                  <div>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel id="demo-simple-select-label">
                        Table no.
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={this.state.selected}
                        onChange={this.onChange}
                        label="Table no."
                      >
                        <MenuItem value="" disabled selected>
                          Select a table
                        </MenuItem>
                        {this.state.allAvailableTable?.map((data, index) => {
                          return data.status === "AVAILABLE" ? (
                            <MenuItem
                              label="Select a table"
                              key={index}
                              value={data.table_number}
                              name={data.table_number}
                            >
                              {data.table_number}
                            </MenuItem>
                          ) : null;
                        })}
                      </Select>
                    </FormControl>
                    {/* <InputLabel htmlFor="outlined-time">Table no.</InputLabel>
                    <Select
                      className="width50"
                      value={this.state.selected}
                      onChange={this.onChange}
                      fullWidth
                      variant="outlined"
                      label="Table no."
                    >
                      {this.state.allAvailableTable?.map((data, index) => {
                        return data.status === "AVAILABLE" ? (
                          <MenuItem
                            label="Select a table"
                            key={index}
                            value={data.table_number}
                            name={data.table_number}
                          >
                            {data.table_number}
                          </MenuItem>
                        ) : null;
                      })}
                    </Select> */}
                  </div>
                ) : (
                  <>
                    <Row className="justify-content-center">
                      <div className="col-9">
                        <TextField
                          className="mt-3 mb-3"
                          fullWidth
                          name="enterTableNumber"
                          // inputProps={{ maxLength: 10 }}
                          value={this.state.enterTableNumber}
                          onChange={this.onChange}
                          // onClick={() => {}}
                          variant="outlined"
                          label="Enter Table Number"
                        />
                      </div>
                    </Row>
                  </>
                )}
                <div className="mt-4 d-flex justify-content-center">
                  <PopupActionButton
                    buttonText="Skip"
                    buttonType="button"
                    buttonClass="noButton"
                    onClick={this.onSkipModal}
                  />
                  <div className="ml-3">
                    {enterTableNumber === "" ? (
                      <button
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                        disabled={true}
                        type="button"
                      >
                        Confirm
                      </button>
                    ) : (
                      <PopupActionButton
                        buttonText="Confirm"
                        buttonType={
                          enterTableNumber === "" ? "button" : "Submit"
                        }
                        buttonClass="yesButton"
                      />
                    )}
                  </div>
                </div>
              </Form>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

TableNumberAdded.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  getSingleEventInfo: state.rsvpEvent.get_single_event_info,
  subscription: state.onboarding.onboard_subscription_details,
  subscription_id:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details._id,
  getAvailableTableData: state.allDinerDetails.get_vendor_available_table_data,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  sa_vd_reset_diner_request,
  vendor_seated_waittime_request,
  rsvp_assign_table_event_request,
  fetch_single_event_rsvp_data_information,
  change_table_status_table_management,
  vendor_get_available_table_action,
  get_new_subscription_for_vendor,
})(withRouter(TableNumberAdded));
